export default __webpack_public_path__ + "static/media/clock-b.c9d2f0c4.svg";